import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const LOGIN_API = `${BASE_URL}getpagedata/login.php`;

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(
        LOGIN_API,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.status === "success") {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        navigate("/dashboard");
      } else {
        setError(res.data.message || "Invalid credentials");
      }
    } catch (err) {
      console.error(err);
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="vh-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundImage: "url('/img/22.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        height:"800px",
      }}
    >
      {/* Elegant Dark Gradient Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(rgb(0 0 0 / 12%), rgb(0 0 0 / 46%))",
        }}
      ></div>

      {/* Login Card */}
      <div
        className="card border-0 shadow-lg p-5"
        style={{
          width: "420px",
          background: "rgba(15, 15, 15, 0.85)",
          backdropFilter: "blur(10px)",
          borderRadius: "18px",
          zIndex: 2,
          border: "1px solid rgba(212, 175, 55, 0.3)",
        }}
      >
        {/* Branding */}
        <div className="text-center mb-4">
          <h2
            className="fw-bold"
            style={{
              fontFamily: "'Playfair Display', serif",
              color: "#d4af37",
              letterSpacing: "1px",
            }}
          >
            Hotel Pahadi
          </h2>
          <p className="text-light opacity-75 small">
            Luxury Administration Portal
          </p>
        </div>

        {error && (
          <div className="alert alert-danger py-2">{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label text-light">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              className="form-control bg-transparent text-light border-secondary"
              value={formData.email}
              onChange={handleChange}
              required
              style={{ borderRadius: "8px" }}
            />
          </div>

          <div className="mb-4">
            <label className="form-label text-light">
              Password
            </label>
            <input
              type="password"
              name="password"
              className="form-control bg-transparent text-light border-secondary"
              value={formData.password}
              onChange={handleChange}
              required
              style={{ borderRadius: "8px" }}
            />
          </div>

          <button
            className="btn w-100 fw-bold"
            disabled={loading}
            style={{
              backgroundColor: "#d4af37",
              color: "#000",
              borderRadius: "8px",
              padding: "10px",
              letterSpacing: "1px",
            }}
          >
            {loading ? "Authenticating..." : "LOGIN"}
          </button>
        </form>

        <div className="text-center mt-4">
          <small className="text-muted">
            © 2026 Hotel Pahadi — Luxury Redefined
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;